module.exports = __webpack_public_path__ + "static/media/6_puhdas-vesi-ja-sanitaatio_en_US.8140f564.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/6_puhdas-vesi-ja-sanitaatio_en_US.svg
// module id = ./src/images/agendaIcons/6_puhdas-vesi-ja-sanitaatio_en_US.svg
// module chunks = 1